window.TC_debouncedPlayerConfigSave = debounce(function(playerInstance) {
    if (playerInstance.currentChannel.id === 0) {
        return;
    }

    let playerConfig = {
       bitrate: playerInstance.bitrateMode,
       channels: {
          channel1: {
              id: playerInstance.currentChannel.id,
              volume: playerInstance.audioChannels.channel1.volume * 100.0
          }
       }
   };

   playerConfig = JSON.stringify(playerConfig);
   
    try {
        localStorage.setItem('calmchristian-player-config', playerConfig);
    } catch (e) {
        console.log('LocalStorage is not available under private mode.');
    }
}, 500);
